import type { ErrorObject } from '@vuelidate/core';

const useValidationErrors = <T extends Record<keyof T, string>>
  (errors: ErrorObject[]): Record<keyof T, string> => errors.reduce((acc, value) => (
    { ...acc, [value.$property]: value.$message }
  ), {} as Record<keyof T, string>);

export default useValidationErrors;
